import React, { Component } from 'react';
import { ArrowLeft, Edit, Plus } from 'lucide-react';
import './PatientDetails.css';

// Bu alt bileşenler daha sonra kendi dosyalarına ayrılabilir
const InfoSection = ({ title, button, content }) => (
    <div className="info-section">
        <div className="section-header">
            <h2>{title}</h2>
            {button}
        </div>
        {content}
    </div>
);

const PatientInfoGrid = ({ patient }) => (
    <div className="info-grid">
        <div className="info-item"><label>Phone Number</label><p>{patient.phone || '-'}</p></div>
        <div className="info-item"><label>Email Address</label><p>{patient.email || '-'}</p></div>
        <div className="info-item"><label>Date of Birth</label><p>{patient.birthDate || '-'}</p></div>
        <div className="info-item"><label>Blood Type</label><p>{patient.bloodType || '-'}</p></div>
        <div className="info-item"><label>Chronic Disease</label><p>{patient.chronicDisease || '-'}</p></div>
        <div className="info-item"><label>Last Examination</label><p>{patient.lastExamination || '-'}</p></div>
        <div className="info-item full-width"><label>Notes</label><p>{patient.notes || '-'}</p></div>
    </div>
);

const ExaminationHistory = ({ examinations }) => (
    <div className="examination-list">
        {examinations && examinations.length > 0 ?
            [...examinations].reverse().map(exam => (
                <div key={exam.id} className="examination-card">
                    <div className="examination-header">
                        <span className="examination-date">{exam.date}</span>
                        <span className="examination-doctor">{exam.doctor}</span>
                    </div>
                    <div className="examination-body">
                        <p className="examination-row"><strong>Complaint:</strong> {exam.complaint}</p>
                        <p className="examination-row"><strong>Diagnosis:</strong> {exam.diagnosis}</p>
                        <p className="examination-row"><strong>Treatment:</strong> {exam.treatment}</p>
                    </div>
                </div>
            )) : <div className="empty-state-small"><p>No examination history found for this patient.</p></div>
        }
    </div>
);

// Ana PatientDetails bileşeni
class PatientDetails extends Component {
    render() {
        const { patient, onBack, onEdit, onNewExamination, onNewDocument, hasPermission } = this.props;

        if (!patient) return null;

        return (
            <div className="patient-details-container">
                <button className="back-button" onClick={onBack}>
                    <ArrowLeft size={16} /> Back to List
                </button>
                <div className="details-header">
                    <div className="details-avatar-section">
                        <div className="details-avatar-large">
                            {patient.firstName.charAt(0)}
                            {patient.lastName.charAt(0)}
                        </div>
                        <div className="details-header-info">
                            <h1>{patient.firstName} {patient.lastName}</h1>
                            <p className="patient-id-large">ID: {patient.nationalId}</p>
                            <span className={`status-badge large ${patient.status.toLowerCase() === 'active' ? 'active' : 'follow-up'}`}>
                                {patient.status}
                            </span>
                        </div>
                    </div>
                    <div className="action-buttons-details">
                        <button 
                            className="edit-btn" 
                            onClick={onEdit}
                            disabled={!hasPermission('editPatient')}
                        >
                            <Edit size={16} /> Edit
                        </button>
                    </div>
                </div>

                <div className="details-tab-content">
                    <InfoSection title="Patient Information" content={<PatientInfoGrid patient={patient} />} />
                    <InfoSection 
                        title="Examination History" 
                        button={hasPermission('addExamination') ? <button className="add-small-btn" onClick={onNewExamination}><Plus size={14} /> New Examination</button> : null}
                        content={<ExaminationHistory examinations={patient.examinations} />} 
                    />
                    {/* Dokümanlar bölümü daha sonra eklenecek */}
                </div>
            </div>
        );
    }
}

export default PatientDetails;
